import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Mail, MessageSquare, MapPin } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", { ...form, type: "contact" });
      toast.success("Message envoyé ! Notre équipe vous répondra sous 24h.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Erreur d'envoi"); } finally { setLoading(false); }
  };

  const infos = [
    { Icon: Mail, label: "E-mail", value: "jamdiam33@gmail.com" },
    { Icon: MapPin, label: "Adresse", value: "127 Chemin de Saint-Joseph, Sainte-Marthe, 13014 Marseille" },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="pt-32 pb-24 px-6 mg-radial">
        <div className="max-w-5xl mx-auto">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <span className="text-xs font-semibold tracking-widest uppercase text-primary">Contact</span>
            <h1 className="font-display text-4xl sm:text-5xl font-extrabold mt-3">Parlons de votre croissance</h1>
            <p className="text-muted-foreground mt-4 text-lg">Une question sur Monaga Adflow ? Notre équipe vous répond rapidement.</p>
          </div>
          <div className="grid lg:grid-cols-3 gap-6">
            <div className="space-y-4">
              {infos.map((i) => (
                <div key={i.label} className="p-5 rounded-2xl border border-border bg-card flex items-start gap-3">
                  <div className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center shrink-0"><i.Icon size={18} className="text-primary" /></div>
                  <div><p className="text-xs text-muted-foreground">{i.label}</p><p className="font-medium text-sm">{i.value}</p></div>
                </div>
              ))}
            </div>
            <form onSubmit={submit} className="lg:col-span-2 p-6 rounded-2xl border border-border bg-card space-y-4">
              <div className="grid sm:grid-cols-2 gap-4">
                <div><Label>Nom</Label><Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5 h-11 rounded-xl" data-testid="contact-name" /></div>
                <div><Label>E-mail</Label><Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5 h-11 rounded-xl" data-testid="contact-email" /></div>
              </div>
              <div><Label>Sujet</Label><Input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="mt-1.5 h-11 rounded-xl" data-testid="contact-subject" /></div>
              <div><Label>Message</Label><Textarea required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1.5 rounded-xl min-h-[120px]" data-testid="contact-message" /></div>
              <Button type="submit" disabled={loading} className="w-full h-11 rounded-xl bg-gradient-to-r from-indigo-500 to-cyan-500 text-white border-0" data-testid="contact-submit"><MessageSquare size={16} className="mr-1.5" /> {loading ? "Envoi…" : "Envoyer le message"}</Button>
            </form>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
